
        Component.define('modal-download-center', (el, params) => {
            /**
 * Cada componente recebe as variáveis explicadas abaixo
 *
 * @param {HTMLElement} el - Elemento DOM que seleciona o componente em si
 * @param {Object} params  - Parâmetros para serem utilizados
 */

const $el             = $(el);
const $btnClose       = $el.find('.btn-close');
const $itemMenu       = $('.button-item-menu');
const $boxItem        = $('.box-item');
const $slider         = $el.find('.wrap-boxes-content');
const $btnDownload    = $el.find('.btn-download');

const makeMenuDownload = () => {
    let className = '.box-item';
    $el.find('.wrap-buttons').show();

    if($el.find('.button-item-menu.active').length > 0){
        let type = $el.find('.button-item-menu.active').attr('data-filter');

        if(type != 'all'){
            className = '.box-item.'+type;
        }
    }

    if($el.find(className).length == 0){
        $el.find('.wrap-buttons').hide();
    }
};

$btnClose.on('click', function(){
    $('.wrapper-modal-download').removeClass('open');
    $body.removeClass('modal-opened');
});

$itemMenu.on('click', function() {
    const value = $(this).attr('data-filter');
    $el.find('.wrap-buttons').show();

    $el.find('.btn-delete-all').attr('data-filter', value);
    $btnDownload.attr('data-filter', value);
    $el.find('.button-item-menu').removeClass('active');
    $(this).addClass('active');

    if(value == 'all') {
        $el.find('.box-item').show();
    }
    else {
        $el.find('.box-item').hide();
        $el.find('.box-item.'+value).show();
    }

    makeMenuDownload();
});

$el.find('.btn-delete-all').on('click', function(){
    const type = $(this).attr('data-filter');
    let ids = [];
    let url = $(this).attr('data-href');
    let className = '.box-item.'+type;

    if(type == 'all'){
        className = '.box-item';
    }
    $el.find(className).each(function(){
        const id = $(this).find('.btn-remove').attr('data-id');
        ids.push(id);
        $(this).remove();
    });

    $el.trigger('file:remove', [ids.join('-'), url]);
    makeMenuDownload();
});

$btnDownload.on('click', function(){
    let urlDownload = $el.attr('data-url-modal');
    let urls = [];
    let ids = [];
    let type = $(this).attr('data-filter');
    let className = '.box-item';

    if(type != 'all'){
        className = '.box-item.' + type;
    }

    if($el.find(className).length == 0) {
        return;
    }

    $el.find(className).each(function(){
        let id = $(this).attr('data-item-id');
        let filename = $(this).attr('data-filename');
        urls.push({download: `${urlDownload}/${id}`, filename: filename });
        ids.push(id);
    });

    console.log(ids);

    //download_files(urls);

    window.open(`${urlDownload}/?ids=${ids.join('-')}`);
    //window.location.href = `${urlDownload}/?ids=${ids.join('-')}`;
});

$el.on('modal-download-center:open', function(){
    makeMenuDownload();
    $el.find('.button-item-menu[data-filter="all"]').trigger('click');
});

let createSlider = false;

$window.on('resize', function(){
    if (wW <= 980) {
        if (!createSlider) {
            $slider.slick({
                arrows: false,
                variableWidth: true
            });

            createSlider = true;
        }
    } else {
        if (createSlider) {
            $slider.slick('unslick');

            createSlider = false;
        }
    }
});

$el.on('file:add', function(e, data){
    if($el.find('.file-'+data.id).length == 0){
        $el.find('.wrap-boxes-content').append(data.html);
        window.SvgFix();
    }
});

$el.on('file:remove', function(e, id, url){
    $.ajax({
        method: "get",
        url: url,
        data: { id: id }
    }).done(function(data) {
        if(data.status){
            console.log(data.ids.length);
            for(let i = 0; i < data.ids.length; i++){
                let _id = data.ids[i];
                $el.find('.file-'+_id).fadeOut(function(){
                    $(this).remove();
                });

                //console.log(_id)
                $('.icon-save[data-id="'+_id+'"]').removeClass('active');
            }
        } else {
            alert('erro');
        }
    }).fail(function() {
        alert('erro 500');
    });
});

        });